import { render } from "./ScPage.vue?vue&type=template&id=07627884&scoped=true&ts=true"
import script from "./ScPage.vue?vue&type=script&lang=ts"
export * from "./ScPage.vue?vue&type=script&lang=ts"

import "./ScPage.vue?vue&type=style&index=0&id=07627884&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.3.1_@vue+comp_8f2c4c49f6fda9a4fff749d98711c87c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07627884"]])

export default __exports__